import React from 'react';

const LancasterFooter = () => {
    return (
        <div className={'LancasterFooter'}>
            <div>Los Angeles County Animal Care Center</div>
            <div>5210 W Ave I</div>
            <div>Lancaster, CA 93536</div>
            <div>(661) 940-4191</div>
        </div>
    );
};

export default LancasterFooter;
